import { render, staticRenderFns } from "./echart-bar.vue?vue&type=template&id=4d52b2e4&scoped=true&"
import script from "./echart-bar.vue?vue&type=script&lang=js&"
export * from "./echart-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d52b2e4",
  null
  
)

export default component.exports